import React from "react";
import OrganizationInviteModal from '../components/modal/OrganizationInviteModal';

type OnboardingInviteProps = {};
const OnboardingInvite: React.FC<OnboardingInviteProps> = () => <OrganizationInviteModal isInAccountLayout />;
export default OnboardingInvite;